export default "__VITE_ASSET__b4330415__"